<div
  class="asc-overlay"
  *ngIf="open"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="mode === 'success' ? 'asc-success-title' : 'asc-dialog-title'"
  [attr.aria-describedby]="mode === 'success' ? 'asc-success-desc' : 'asc-dialog-desc'"
>
  <button type="button" class="asc-backdrop" (click)="onBackdropClick()" aria-label="Close"></button>

  <div
    class="asc-card"
    [class.asc-card--sa]="theme === 'sa'"
    [class.asc-card--sb]="theme === 'sb'"
    (click)="$event.stopPropagation()"
  >
    <div class="asc-icon-wrap" aria-hidden="true">
      <span class="asc-spark asc-spark--1"></span>
      <span class="asc-spark asc-spark--2"></span>
      <span class="asc-spark asc-spark--3"></span>
      <span class="asc-icon-ring" [class.asc-icon-ring--success]="mode === 'success'">
        <i class="fa" [ngClass]="mode === 'success' ? 'fa-thumbs-up' : 'fa-paper-plane'"></i>
      </span>
    </div>

    <ng-container *ngIf="mode === 'confirm'">
      <h2 id="asc-dialog-title" class="asc-title">Submit assessment?</h2>
      <p id="asc-dialog-desc" class="asc-text">
        Are you sure you want to submit the assessment? Once submitted, you cannot change your answers.
      </p>
      <div class="asc-actions">
        <button type="button" class="asc-btn asc-btn-ghost" (click)="onCancel()">Cancel</button>
        <button type="button" class="asc-btn asc-btn-primary" (click)="onConfirm()">Submit</button>
      </div>
    </ng-container>

    <ng-container *ngIf="mode === 'success'">
      <h2 id="asc-success-title" class="asc-title">{{ successTitle }}</h2>
      <p id="asc-success-desc" class="asc-text asc-text--success">{{ successMessage }}</p>
      <div class="asc-actions asc-actions--single">
        <button type="button" class="asc-btn asc-btn-primary" (click)="onDismiss()">OK</button>
      </div>
    </ng-container>
  </div>
</div>

